import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { getRecommendations } from '../actions/recommendations';

export default handleActions({
  [getRecommendations]: {
    next(state = {}, { payload, meta: { documentId } }) {
      return {
        ...state,
        [documentId]: payload
      };
    },
    throw(state = {}, { meta: { documentId } }) {
      return {
        ...state,
        [documentId]: { error: true, message: `Document Recommendations failed to load ${documentId || ''}` }
      };
    }
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/recommendations.js